"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeWithFontMultiplier = void 0;
var atlanticTheme_1 = __importStar(require("./atlanticTheme"));
var chameleonTheme_1 = __importStar(require("./chameleonTheme"));
var gowizardTheme_1 = __importStar(require("./gowizardTheme"));
var indigoTheme_1 = __importStar(require("./indigoTheme"));
var rhubarbTheme_1 = __importStar(require("./rhubarbTheme"));
var auroraTheme_1 = __importStar(require("./auroraTheme"));
var apricotTheme_1 = __importStar(require("./apricotTheme"));
var themeCreator_1 = __importStar(require("./themeCreator"));
var themes = {
    atlantic: atlanticTheme_1.default,
    chameleon: chameleonTheme_1.default,
    gowizard: gowizardTheme_1.default,
    indigo: indigoTheme_1.default,
    rhubarb: rhubarbTheme_1.default,
    aurora: auroraTheme_1.default,
    apricot: apricotTheme_1.default,
    custom: themeCreator_1.customTheme,
};
var getThemeWithFontMultiplier = function (theme, fontSizeMultiplier) {
    if (fontSizeMultiplier === void 0) { fontSizeMultiplier = 1; }
    if (theme === 'atlantic') {
        return (0, themeCreator_1.default)(atlanticTheme_1.atlanticPalette, atlanticTheme_1.default.typography.fontFamily, fontSizeMultiplier);
    }
    if (theme === 'chameleon') {
        return (0, themeCreator_1.default)(chameleonTheme_1.chameleonPalette, chameleonTheme_1.default.typography.fontFamily, fontSizeMultiplier);
    }
    if (theme === 'gowizard') {
        return (0, themeCreator_1.default)(gowizardTheme_1.gowizardPalette, gowizardTheme_1.default.typography.fontFamily, fontSizeMultiplier);
    }
    if (theme === 'indigo') {
        return (0, themeCreator_1.default)(indigoTheme_1.indigoPalette, indigoTheme_1.default.typography.fontFamily, fontSizeMultiplier);
    }
    if (theme === 'rhubarb') {
        return (0, themeCreator_1.default)(rhubarbTheme_1.rhubarbPalette, rhubarbTheme_1.default.typography.fontFamily, fontSizeMultiplier);
    }
    if (theme === 'aurora') {
        return (0, themeCreator_1.default)(auroraTheme_1.auroraPalette, auroraTheme_1.default.typography.fontFamily, fontSizeMultiplier);
    }
    if (theme === 'apricot') {
        return (0, themeCreator_1.default)(apricotTheme_1.apricotPalette, apricotTheme_1.default.typography.fontFamily, fontSizeMultiplier);
    }
    if (theme === 'custom') {
        return (0, themeCreator_1.default)(themeCreator_1.customPalette, themeCreator_1.customTheme.typography.fontFamily, fontSizeMultiplier);
    }
    return (0, themeCreator_1.default)(chameleonTheme_1.chameleonPalette, chameleonTheme_1.default.typography.fontFamily, fontSizeMultiplier);
};
exports.getThemeWithFontMultiplier = getThemeWithFontMultiplier;
exports.default = themes;
//# sourceMappingURL=themes.js.map